import React from "react"
import CreatableSelect from "react-select/creatable"
import { FormGroup, Label, FormFeedback } from "reactstrap"

const FormikCreatableSelect = ({
  label,
  name,
  formik,
  options,
  isLoading,
  placeholder = "Escribe o Selecciona",
  onCreateOption,
  customOnChange, // función personalizada opcional
  ...props
}) => {
  const handleChange = newValue => {
    if (newValue && newValue.label) {
      formik.setFieldValue(name, newValue.label)
    } else {
      formik.setFieldValue(name, "")
    }

    if (typeof customOnChange === "function") {
      customOnChange(newValue)
    }
  }

  return (
    <FormGroup>
      <Label for={name}>{label}</Label>
      <CreatableSelect
        id={name}
        name={name}
        isClearable
        isDisabled={isLoading}
        isLoading={isLoading}
        placeholder={placeholder}
        onChange={handleChange}
        onBlur={() => formik.setFieldTouched(name, true)}
        onCreateOption={onCreateOption}
        options={options}
        value={options.find(opt => opt.label === formik.values[name]) || null}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: base => ({ ...base, zIndex: 9999 }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? "#556ee6" : "#fff",
            color: state.isSelected ? "white" : "black",
            ":hover": {
              backgroundColor: "#556ee6",
              color: "white",
            },
          }),
          menu: provided => ({
            ...provided,
            borderRadius: "8px",
            overflow: "hidden",
          }),
        }}
        {...props}
      />
      {formik.touched[name] && formik.errors[name] && (
        <FormFeedback className="d-block">{formik.errors[name]}</FormFeedback>
      )}
    </FormGroup>
  )
}

export default FormikCreatableSelect
